import { hidrotestAdimiMi, pwhtAdimiMi, testAdimiMi } from "./rota.js";
/**
 * D-074 Faz 2 (plan §5.12): adım başına rapor listesi. `tamir_kalemi.docs[<adım adı>]` üç biçimde durabilir: eski tek belge kimliği
 * (string), eski `true` (kayıt var, belge kimliği yok) ve yeni belge kimliği listesi (string[]). Eski değerler dönüştürülmez (canlı veri
 * UPDATE edilmez); okuyan her yer bu yardımcılardan geçer. Yeni yazım her zaman liste yazar, boş liste asla saklanmaz: eski kod
 * `Boolean([])` ile "rapor var" derdi.
 */
/** `docs` nesne değilse (null, dizi, metin) boş nesne sayılır. */
const nesne = (docs) => docs && typeof docs === "object" && !Array.isArray(docs) ? docs : {};
/** Adımın rapor belgeleri (sıra korunur, tekrar ve boş değer atılır); `true` ve bozuk değer → []. */
export function adimRaporlari(docs, ad) {
    const v = nesne(docs)[ad];
    if (typeof v === "string")
        return v.trim() ? [v] : [];
    if (!Array.isArray(v))
        return [];
    const sonuc = [];
    for (const x of v)
        if (typeof x === "string" && x.trim() && !sonuc.includes(x))
            sonuc.push(x);
    return sonuc;
}
/** Adımın raporu var mı: `true` ya da en az bir belge kimliği. */
export function adimRaporuVar(docs, ad) {
    return nesne(docs)[ad] === true || adimRaporlari(docs, ad).length > 0;
}
/** Belgeyi adımın listesine ekler (yoksa); yeni nesne döner, girdiyi değiştirmez. Eski `true` → [id]; eski "x" → ["x", id]. */
export function adimRaporuEkle(docs, ad, dokumanId) {
    const liste = adimRaporlari(docs, ad);
    return { ...nesne(docs), [ad]: liste.includes(dokumanId) ? liste : [...liste, dokumanId] };
}
/** Belgeyi listeden çıkarır; liste boşalırsa anahtar silinir. Belge listede değilse ya da değer `true` ise nesne aynen (kopya) döner. */
export function adimRaporuCikar(docs, ad, dokumanId) {
    const kopya = { ...nesne(docs) };
    const liste = adimRaporlari(kopya, ad);
    if (kopya[ad] === true || !liste.includes(dokumanId))
        return kopya;
    const kalan = liste.filter((x) => x !== dokumanId);
    if (kalan.length)
        kopya[ad] = kalan;
    else
        delete kopya[ad];
    return kopya;
}
/** Rapor alan adım: test adımı (hidrotest hariç) ya da PWHT. Documents seçicisi ve referans ucu aynı kuralı kullanır. */
export const adimRaporAlirMi = (ad) => (testAdimiMi(ad) && !hidrotestAdimiMi(ad)) || pwhtAdimiMi(ad);
/** Kapanmış adıma eklenen referans raporunun adım kaydı tipi (adım raporu sayılmaz). */
export const ADIM_REFERANS_LOG_TIPI = "ref";
/** Bir yüklemede en çok kaç sayfa aralığı (her aralık bir rapor). */
export const ADIM_RAPORU_EN_COK_ARALIK = 20;
//# sourceMappingURL=adim-raporu.js.map